import React, { useState } from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Text from '~/shared/components/Text';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { Component as Stars } from '../Stars';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledText = styled(Text).attrs({
  forwardedAs: 'h1',
})`
  text-align: left;
  padding-bottom: 15px;
  ${({ isRequired, theme }) =>
    isRequired &&
    css`
      ::after {
        content: '*';
        color: ${theme.colors.textDefault};
      }
    `}
`;

const StyledStars = styled(Stars)`
  & > span {
    ${({ theme, initialRating }) => css`
      color: ${initialRating > 0 ? theme.colors.iconColor : 'inherit'};
      :hover {
        color: ${theme.colors.iconColor};
      }
    `}
  }
`;

const DynamicFormattedMessage = FormattedMessage;

const ReviewOptionStars = ({ option, onChange, rbKey, title, ...rest }) => {
  const [ratings, setRatings] = useState({
    rating: 0,
    id: null,
    reviewTemplateFieldAnswerId: null,
  });

  const handleChange = (rating) => {
    // We need to determine what object to send up to the parent. This rating should pertain to the option's sort value
    const rateObject = option.answers.find((answer) => answer.sort === rating);
    const nextState = {
      ...ratings,
      reviewTemplateFieldAnswerId: rateObject.reviewTemplateFieldAnswerId,
      id: rateObject.reviewTemplateFieldId,
    };
    setRatings({ ...nextState, rating });
    onChange(nextState);
  };

  return (
    <Wrapper {...rest}>
      <StyledText variant="formLabelEmphasized" isRequired={option.required}>
        <DynamicFormattedMessage id={rbKey} defaultMessage={title} />
      </StyledText>
      <StyledStars
        stop={option.answers.length}
        size={36}
        initialRating={ratings.rating}
        quiet={false}
        fractions={1}
        onChange={handleChange}
        isBlackBorder
      />
    </Wrapper>
  );
};

ReviewOptionStars.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
  rbKey: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default ReviewOptionStars;
